import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MarkdownModule } from 'ngx-markdown';
import { QuillModule } from 'ngx-quill';

import { SharedModule } from '../../shared/shared.module';
import { AssignmentScheduleRoutingModule } from './assignment-schedule-routing.module';
import { AssignmentScheduleAnswerAdditionModalComponent } from './components/assignment-schedule-answer-addition-modal/assignment-schedule-answer-addition-modal.component';
import { AssignmentScheduleAnswerDisplayComponent } from './components/assignment-schedule-answer-filter-display/assignment-schedule-answer-filter-display.component';
import { AssignmentScheduleAnswerFilterModalComponent } from './components/assignment-schedule-answer-filter-modal/assignment-schedule-answer-filter-modal.component';
import { AssignmentScheduleAnswerOptionComponent } from './components/assignment-schedule-answer-option/assignment-schedule-answer-option.component';
import { AssignmentScheduleAnswerOverviewComponent } from './components/assignment-schedule-answer-overview/assignment-schedule-answer-overview.component';
import { AssignmentScheduleAnswerComponent } from './components/assignment-schedule-answer/assignment-schedule-answer.component';
import { OpenAssignmentSchedulesComponent } from './components/open-assignment-schedules/open-assignment-schedules.component';

@NgModule({
    imports: [
        NgSelectModule,
        CommonModule,
        SharedModule,
        AssignmentScheduleRoutingModule,
        QuillModule.forRoot(),
        MarkdownModule.forRoot()
    ],
    declarations: [
        OpenAssignmentSchedulesComponent,
        AssignmentScheduleAnswerComponent,
        AssignmentScheduleAnswerOptionComponent,
        AssignmentScheduleAnswerDisplayComponent,
        AssignmentScheduleAnswerOverviewComponent,
        AssignmentScheduleAnswerAdditionModalComponent,
        AssignmentScheduleAnswerFilterModalComponent
    ],
    exports: [
        AssignmentScheduleAnswerOptionComponent
    ],
    providers: [],
})
export class AssignmentScheduleModule { }
